export default {
    firstName: {
        type: "string",
        required: true,
    },
    lastName: {
        type: "string",
        required: true,
    },
    dateOfBirth: {
        type: "date",
        required: true,
    },
    personalCode: {
        type: "string",
        required: true,
    },
    citizenship: {
        type: "string",
        required: true,
    },
    taxCountry: {
        type: "string",
        required: true,
    },
    taxNumber: {
        type: "string",
        required: true,
    },
    addressLine: {
        type: "string",
        required: true,
    },
    addressCity: {
        type: "string",
        required: true,
    },
    addressCountry: {
        type: "string",
        required: true,
    },
    addressPostcode: {
        type: "string",
        required: true,
    },
    isPep: {
        type: "boolean",
        required: false,
    },
    isUS: {
        type: "boolean",
        required: false,
    },
}
